
export function wait_message(type: string) {
    return new Promise((accept, reject) => {
        const timeout = setTimeout(() => {
            cleanup();
            reject();
        }, 250);

        const cleanup = () => {
            clearTimeout(timeout);
            window.removeEventListener("message", handler);
        }

        const handler = (ev: MessageEvent) => {
            let msg: any = ev.data;

            try {
                msg = JSON.parse(msg);
            } catch { }

            if (msg.type == type) {
                cleanup();
                accept(msg);
            }
        }

        window.addEventListener("message", handler)
    })
}
